// extracted by mini-css-extract-plugin
export var actions = "_uj-4";
export var item = "_uj-1";
export var price = "_uj-3";
export var quantity = "_uj-2";
export var table = "_uj-0";